"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var core_1 = require("@angular/core");
var traveler_detail_view_config_model_1 = require("./traveler-detail-view-config.model");
var policy_view_config_model_1 = require("./policy-view-config.model");
var base_field_config_model_1 = require("./base-field-config.model");
var field_configs_model_1 = require("./field-configs.model");
var trip_dates_config_model_1 = require("./trip-dates-config.model");
var RulesService = RulesService_1 = (function () {
    function RulesService() {
    }
    RulesService.prototype.buildFieldConfigs = function (rules, mode) {
        var config = new field_configs_model_1.FieldConfigs();
        config.policyHolder = this.getDefaultTravelerConfiguration(mode);
        config.additionalTraveler = this.getDefaultAdditionalTravelerConfiguration(mode);
        config.policy = this.getDefaultPolicyConfiguration();
        if (rules) {
            if (rules.policy) {
                config.policy = this.mapPolicyRules(rules.policy, mode);
            }
            if (rules.policyHolder) {
                config.policyHolder = this.mapTravelerRules(rules.policyHolder, mode);
            }
            if (rules.additionalTraveler) {
                config.additionalTraveler = this.mapTravelerRules(rules.additionalTraveler, mode);
            }
        }
        return config;
    };
    RulesService.prototype.mapPolicyRules = function (data, mode) {
        var mappedConfiguration = new policy_view_config_model_1.PolicyViewConfig();
        mappedConfiguration.depositDate = this.buildFieldConfig(data.depositDate);
        mappedConfiguration.destination = this.buildFieldConfig(data.destination);
        mappedConfiguration.flights = this.buildFieldConfig(data.flights);
        mappedConfiguration.state = this.buildFieldConfig(data.state);
        mappedConfiguration.tripCost = this.buildFieldConfig(data.tripCost);
        mappedConfiguration.airline = this.buildFieldConfig(data.airline);
        mappedConfiguration.carRentalCompany = this.buildFieldConfig(data.carRentalCompany);
        mappedConfiguration.cruiseLine = this.buildFieldConfig(data.cruiseLine);
        mappedConfiguration.hotel = this.buildFieldConfig(data.hotel);
        mappedConfiguration.rentalCompany = this.buildFieldConfig(data.rentalCompany);
        mappedConfiguration.tourOperator = this.buildFieldConfig(data.tourOperator);
        // We want to turn off these fields that were previously controled by "destination"
        mappedConfiguration.destinationState = this.buildDefaultConfig(false, false, false);
        mappedConfiguration.destinationCity = this.buildDefaultConfig(false, false, false);
        // HACK - trip dates are editable for AirCare products, but this is so
        // the dates can change as a result of flight changes. If dates aren't
        // required, then hide the fields for quoting
        mappedConfiguration.tripDates = this.buildTripDatesFieldConfig(data.tripDates);
        if (!mappedConfiguration.tripDates.required) {
            mappedConfiguration.tripDates.show = false;
        }
        // sets configuration up for purchase
        if (mode === RulesService_1.PURCHASE_MODE) {
            mappedConfiguration.isPurchase = true;
        }
        return mappedConfiguration;
    };
    RulesService.prototype.mapTravelerRules = function (data, mode) {
        var mappedConfiguration = new traveler_detail_view_config_model_1.TravelerDetailViewConfig();
        // todo: Pass in min / max length and other values as part of configuration object
        mappedConfiguration.firstName = this.buildFieldConfig(data.firstName);
        mappedConfiguration.lastName = this.buildFieldConfig(data.lastName);
        mappedConfiguration.birthDate = this.buildFieldConfig(data.birthdate);
        mappedConfiguration.email = this.buildFieldConfig(data.email);
        mappedConfiguration.phoneNumber = this.buildFieldConfig(data.phoneNumber);
        mappedConfiguration.residence = this.buildFieldConfig(data.address);
        mappedConfiguration.address = this.buildFieldConfig(data.address);
        mappedConfiguration.tripCost = this.buildFieldConfig(data.tripCost);
        mappedConfiguration.gender = this.buildFieldConfig(data.gender);
        mappedConfiguration.relationshipToPolicyholder = this.buildFieldConfig(data.relationshipToPolicyholder);
        mappedConfiguration.age = this.buildDefaultConfig(false, false, false);
        // OVERRIDES
        if (mode === RulesService_1.EDIT_MODE) {
            // residence isn't displayed for edit, but address is
            mappedConfiguration.residence = this.buildDefaultConfig(false, false, false);
            mappedConfiguration.age = this.buildDefaultConfig(false, false, mappedConfiguration.birthDate.show);
        }
        else if (mode === RulesService_1.PURCHASE_MODE) {
            // All should be editable during purchase
            mappedConfiguration.firstName.editable = true;
            mappedConfiguration.lastName.editable = true;
            mappedConfiguration.birthDate.editable = true;
            mappedConfiguration.email.editable = true;
            mappedConfiguration.phoneNumber.editable = true;
            mappedConfiguration.residence.editable = true;
            mappedConfiguration.address.editable = true;
            mappedConfiguration.tripCost.editable = true;
        }
        return mappedConfiguration;
    };
    RulesService.prototype.getDefaultPolicyConfiguration = function () {
        var newConfiguration = new policy_view_config_model_1.PolicyViewConfig();
        newConfiguration.tripDates = this.buildDefaultConfig(true, true, true);
        newConfiguration.depositDate = this.buildDefaultConfig(true, true, true);
        newConfiguration.destination = this.buildDefaultConfig(true, true, true);
        newConfiguration.state = this.buildDefaultConfig(true, true, true);
        newConfiguration.tripCost = this.buildDefaultConfig(true, true, true);
        newConfiguration.airline = this.buildDefaultConfig(true, true, true);
        newConfiguration.carRentalCompany = this.buildDefaultConfig(false, true, true);
        newConfiguration.cruiseLine = this.buildDefaultConfig(false, true, true);
        newConfiguration.hotel = this.buildDefaultConfig(false, true, true);
        newConfiguration.flights = this.buildDefaultConfig(false, false, false);
        // We want to turn off these fields that were previously controled by "destination"
        newConfiguration.destinationState = this.buildDefaultConfig(false, false, false);
        newConfiguration.destinationCity = this.buildDefaultConfig(false, false, false);
        return newConfiguration;
    };
    RulesService.prototype.getDefaultTravelerConfiguration = function (mode) {
        var newConfiguration = new traveler_detail_view_config_model_1.TravelerDetailViewConfig();
        newConfiguration.firstName = this.buildDefaultConfig(true, true, true);
        newConfiguration.lastName = this.buildDefaultConfig(true, true, true);
        newConfiguration.birthDate = this.buildDefaultConfig(true, true, true);
        newConfiguration.email = this.buildDefaultConfig(true, true, true);
        newConfiguration.phoneNumber = this.buildDefaultConfig(true, true, true);
        newConfiguration.residence = this.buildDefaultConfig(true, true, true);
        newConfiguration.address = this.buildDefaultConfig(true, true, true);
        newConfiguration.tripCost = this.buildDefaultConfig(false, false, false);
        newConfiguration.gender = this.buildDefaultConfig(false, false, false);
        newConfiguration.relationshipToPolicyholder = this.buildDefaultConfig(false, false, false);
        newConfiguration.age = this.buildDefaultConfig(false, false, false);
        // OVERRIDES
        if (mode === RulesService_1.EDIT_MODE) {
            newConfiguration.residence = this.buildDefaultConfig(false, false, false);
            newConfiguration.age = this.buildDefaultConfig(false, false, newConfiguration.birthDate.show);
        }
        else if (mode === RulesService_1.PURCHASE_MODE) {
            // All should be editable during purchase
            newConfiguration.firstName.editable = true;
            newConfiguration.lastName.editable = true;
            newConfiguration.birthDate.editable = true;
            newConfiguration.email.editable = true;
            newConfiguration.phoneNumber.editable = true;
            newConfiguration.residence.editable = true;
            newConfiguration.address.editable = true;
            newConfiguration.tripCost.editable = true;
        }
        return newConfiguration;
    };
    RulesService.prototype.getDefaultAdditionalTravelerConfiguration = function (mode) {
        var newConfiguration = new traveler_detail_view_config_model_1.TravelerDetailViewConfig();
        newConfiguration.firstName = this.buildDefaultConfig(true, true, true);
        newConfiguration.lastName = this.buildDefaultConfig(true, true, true);
        newConfiguration.birthDate = this.buildDefaultConfig(true, true, true);
        newConfiguration.email = this.buildDefaultConfig(false, true, true);
        newConfiguration.phoneNumber = this.buildDefaultConfig(false, false, false);
        newConfiguration.residence = this.buildDefaultConfig(false, false, false);
        newConfiguration.address = this.buildDefaultConfig(false, false, false);
        newConfiguration.tripCost = this.buildDefaultConfig(false, false, false);
        newConfiguration.gender = this.buildDefaultConfig(false, false, false);
        newConfiguration.relationshipToPolicyholder = this.buildDefaultConfig(true, true, true);
        newConfiguration.age = this.buildDefaultConfig(false, false, false);
        // OVERRIDES
        if (mode === RulesService_1.EDIT_MODE) {
            newConfiguration.residence = this.buildDefaultConfig(false, false, false);
            newConfiguration.age = this.buildDefaultConfig(false, false, newConfiguration.birthDate.show);
        }
        else if (mode === RulesService_1.PURCHASE_MODE) {
            // All should be editable during purchase
            newConfiguration.firstName.editable = true;
            newConfiguration.lastName.editable = true;
            newConfiguration.birthDate.editable = true;
            newConfiguration.email.editable = true;
            newConfiguration.phoneNumber.editable = true;
            newConfiguration.residence.editable = true;
            newConfiguration.address.editable = true;
            newConfiguration.tripCost.editable = true;
        }
        return newConfiguration;
    };
    RulesService.prototype.buildTripDatesFieldConfig = function (config) {
        var mappedConfig = new trip_dates_config_model_1.TripDatesFieldConfig();
        this.populateFieldConfig(config, mappedConfig);
        return mappedConfig;
    };
    RulesService.prototype.populateFieldConfig = function (config, target) {
        if (config && target) {
            target.required = config.required;
            target.editable = config.editable;
            target.show = config.show;
        }
    };
    RulesService.prototype.buildFieldConfig = function (config) {
        if (config) {
            var mappedConfig = new base_field_config_model_1.BaseFieldConfig();
            this.populateFieldConfig(config, mappedConfig);
            return mappedConfig;
        }
        // default won't require, show, or allow edits
        return new base_field_config_model_1.BaseFieldConfig();
    };
    RulesService.prototype.buildDefaultConfig = function (required, editable, show) {
        var config = new base_field_config_model_1.BaseFieldConfig();
        config.required = required;
        config.editable = editable;
        config.show = show;
        return config;
    };
    return RulesService;
}());
RulesService.PURCHASE_MODE = 'purchase';
RulesService.EDIT_MODE = 'edit';
RulesService = RulesService_1 = __decorate([
    core_1.Injectable(),
    __metadata("design:paramtypes", [])
], RulesService);
exports.RulesService = RulesService;
var RulesService_1;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/view-config-models/rules.service.js